class SearchArticles extends HTMLElement {
  constructor() {
    super();
    this.endpoint = 'https://myline24.de/api/2024-04/graphql.json';
    this.token = 'f670fe0536b95e399f03f23b45f0f3f4';
  }

  connectedCallback() {
    this.form = this.querySelector('form');
    this.resultsContainer = document.querySelector('[js-articles-grid]');
    this.paginationEl = document.querySelector('[js-pagination]');

    this.form.addEventListener('submit', (e) => {
      e.preventDefault();
      const query = this.form.querySelector('input[name="query"]').value.trim().toLowerCase();
      if (query) {
        this.searchArticles(query);
      }
    });
  }

  async searchArticles(searchTerm) {
    const tagged = location.pathname.includes('tagged');
    let input = 'first: 250';

    if(tagged) {
        const tag = this.getAttribute('data-tag-name');
        input = `query:"tag:'${tag}'",first: 250`;
    }

    const graphqlQuery = `
      {
        articles(${input}) {
          edges {
            node {
              title
              handle
              tags
              blog {
                handle
              }
              image {
                url
                altText
              }
              metafields(identifiers: [
                { namespace: "custom", key: "recipe_ingredients" },
                { namespace: "custom", key: "recipe_calories" }
              ]) {
                key
                value
                reference {
                  ... on Metaobject {
                    fields {
                      key
                      value
                    }
                  }
                }
              }
            }
          }
        }
      }
    `;

    const response = await fetch(this.endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': this.token,
      },
      body: JSON.stringify({ query: graphqlQuery }),
    });

    const { data } = await response.json();

    if (!data) return;

    const articles = data.articles.edges.map(edge => {
      const node = edge.node;
      const metafields = node.metafields || [];

      const ingredientsMeta = metafields.find(mf => mf?.key === 'recipe_ingredients');
      const caloriesMeta = metafields.find(mf => mf?.key === 'recipe_calories');

      const refFields = ingredientsMeta?.reference?.fields || [];

      const nutritionalField = refFields.find(f => f.key === 'nutritional_value_text');
      const nutritionalText = nutritionalField?.value
        ?.toLowerCase()
        ?.normalize("NFD")
        ?.replace(/[\u0300-\u036f]/g, '') || '';

      return {
        ...node,
        nutritional_value_text: nutritionalText,
        recipe_calories: caloriesMeta?.value || ''
      };
    });

    const filtered = articles.filter(article =>
      article.nutritional_value_text.includes(searchTerm)
    );

    this.renderResults(filtered);
    this.paginationEl.classList.add("hidden");
  }

  renderResults(articles) {
    if (!articles.length) {
      this.resultsContainer.innerHTML = `<p>No results found.</p>`;
      this.resultsContainer.scrollIntoView({ behavior: 'smooth' });
      return;
    }

    this.resultsContainer.innerHTML = articles.map(article => {
      const imageUrl = article.image?.url;
      const altText = article.image?.altText || article.title;
      const blogHandle = article.blog?.handle;
      const calories = article.recipe_calories;

      return `
        <li class="blog__article-item animation-fade-up-reveal">
          ${imageUrl ? `
            <a href="/blogs/${blogHandle}/${article.handle}" class="hover">
              <div class="image blog__article-image">
                <img src="${imageUrl}" alt="${altText}" class="image__img" loading="lazy" />
              </div>
            </a>` : `
            <div class="blog__article-image placeholder-image">
              <svg class="placeholder-svg" width="100%" height="100%">
                <rect width="100%" height="100%" fill="#ccc"></rect>
              </svg>
            </div>`}
          <div class="blog__meta ${!imageUrl ? 'blog__meta--no-image' : ''}">
            <div class="custom-blog__title--wrap">
              <h3 class="blog__article-title ff-heading ta-c">
                <a href="/blogs/${blogHandle}/${article.handle}">${article.title}</a>
              </h3>
              ${calories ? `
                <span class="custom-blog__recipes--icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="8" height="9" viewBox="0 0 8 9" fill="none">
                    <circle cx="4" cy="4.5" r="4" fill="#161616"/>
                  </svg>
                </span>
                <div class="custom-blog__detail--wrap">
                  <span class="custom-blog__text">${calories}</span>
                </div>` : ''}
            </div>
          </div>
        </li>
      `;
    }).join('');

    this.resultsContainer.scrollIntoView({ behavior: 'smooth' });
  }
}

customElements.define('search-articles', SearchArticles);